





































































































import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import Back from '@modules/ui/buttons/Back'
import EventPOILocations from '@ui/Event/EventPOILocations'
import AddPOILocationTriggerModal from '@ui/triggers/POI/AddPOILocationTriggerModal'
import EditPOILocationTriggerModal from '@ui/triggers/POI/EditPOILocationTriggerModal'
import RemovePOILocationTriggerModal from '@ui/triggers/POI/RemovePOILocationTriggerModal'
import POILocationCSVImportTriggerModal from '@ui/triggers/POI/POILocationCSVImportTriggerModal'

settings =
  name: 'POIShow'

  resources:
    item:
      resourceName: 'poi'
      slug: 'pois/:poiId'

  vue:
    components: {
      SuperContainerView,
      Back,
      EventPOILocations
      AddPOILocationTriggerModal,
      EditPOILocationTriggerModal,
      RemovePOILocationTriggerModal,
      POILocationCSVImportTriggerModal,
    }

    props: ['poiId']

    data: ->
      showAll: false

    methods:
      hiTogglePOIEnabled: (value) ->
        @triggerResource 'item', 'update_enabled', { value }

      hiAddPOILocationTrigger: -> @$refs.addPOILocationTrigger.fire()
      onItemAddPoiLocation: -> @$refs.addPOILocationTrigger.close()

      hiEditPOILocationTrigger: (location) ->
        payloadOptions = {}
        modalOptions = { location }
        @$refs.editPOILocationTrigger.fire(payloadOptions, modalOptions)
      onItemEditPoiLocation: -> @$refs.editPOILocationTrigger.close()

      hiRemoveLocationTrigger: (location) ->
        payloadOptions = { poi_location_id: location.id }
        @$refs.removePOILocationTrigger.fire(payloadOptions)
      onItemRemovePoiLocation: -> @$refs.removePOILocationTrigger.close()

      hiPOILocationCSVImportTrigger:  -> @$refs.poiLocationCSVImportTrigger.fire()
      onItemPoiLocationCsvImport: -> @$refs.poiLocationCSVImportTrigger.close()

      formatAddress: (location) ->
        return location.full_address if location.full_address
        full_address = [location.address, location.city, location.state, location.country, location.zip]
        full_address.filter((item) -> !!item).join(', ')

export default VueOptions.vue settings
